import React from "react";
import { object } from "prop-types";
import { WeddingTeaserForm } from "./WeddingTeaserForm";
import { WeddingFullForm } from "./WeddingFullForm";
// eslint-disable-next-line import/no-cycle
import { WeddingModalForm } from "./WeddingModalForm";

const WeddingFormConnector = ({ data }) => {
	let renderedComponent = null;

	if (data?.type === "teaser" && data?.iframeUrl) {
		renderedComponent = <WeddingTeaserForm config={data} />;
	} else if (data?.type === "full" && data?.iframeUrl) {
		renderedComponent = <WeddingFullForm config={data} />;
	} else if ((data?.type === "modal" || data?.type === "iframe") && data?.iframeUrl) {
		renderedComponent = <WeddingModalForm config={data} />;
	}

	return renderedComponent;
};

WeddingFormConnector.propTypes = {
	data: object,
};

WeddingFormConnector.defaultProps = {
	data: null,
};

export default WeddingFormConnector;
export { WeddingFormConnector };
